import {
  HateoasResource,
  HateoasProjection,
  ProjectionRelType
} from "@lagoshny/ngx-hateoas-client";
import { Skill } from "./skill";
import { BaseEntity } from "@app/models/rest/base-entity";
import { ResourceFactMappingPattern } from "./resource-fact-mapping-pattern";
import { ResourceModel } from "./resource";

@HateoasResource("resourceSkills")
export class ResourceSkill extends BaseEntity {
  skill: ProjectionRelType<Skill>;
  resource: ProjectionRelType<ResourceModel>;
  startDate: Date;
  endDate: Date;
  mappingPattern: ProjectionRelType<ResourceFactMappingPattern>;
}

/**
 * Detail projection that includes all related entities needed for the resource-skill-mapping component
 */
@HateoasProjection(ResourceSkill, "detail")
export class ResourceSkillDetailProjection extends BaseEntity {
  resource: ProjectionRelType<ResourceModel>;
  skill: ProjectionRelType<Skill>;
  startDate: Date;
  endDate: Date;
  mappingPattern: ProjectionRelType<ResourceFactMappingPattern>;
}
